class MVisitorCounter extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      liveViews: [".m-product-live-views"],
      stockCountdowns: [".m-product-inventory__status"],
    };
  }

  connectedCallback() {
    this.init();
  }

  init() {
    try {
      this.domNodes = queryDomNodes(this.selectors);
      this.initLiveViews();
      this.initStockCountdowns();
    } catch (error) {
      console.error("Failed to init Boost Sales Helper");
    }
  }

  initLiveViews() {
    this.domNodes.liveViews &&
      this.domNodes.liveViews.forEach((liveViews) => {
        if (liveViews.dataset.initialized !== "true") {
          const liveViewElem = liveViews.querySelector(".live-views-text");
          const settings = liveViews.dataset;
          if (liveViewElem) {
            const lvtHTML = liveViewElem.innerHTML;
            liveViewElem.innerHTML = lvtHTML.replace(
              settings.liveViewsCurrent,
              `<span class="live-view-numb">${settings.liveViewsCurrent}</span>`
            );
            this.changeLiveViewsNumber(liveViewElem, settings);
          }
          liveViews.dataset.initialized = true;
        }
      });
  }

  initStockCountdowns() {
    this.domNodes.stockCountdowns &&
      this.domNodes.stockCountdowns.forEach((stockCountdown) => {
        if (stockCountdown.dataset.initialized !== "true") {
          const html = stockCountdown.innerHTML;
          const currentNumberMatch = html.match(/(\d+)/);
          if (currentNumberMatch) {
            const min = 1;
            const max = 12;
            const randomStock = Math.floor(Math.random() * (max - min + 1)) + min;
            // Use regex replacement to ensure we only replace the number part
            stockCountdown.innerHTML = html.replace(currentNumberMatch[0], randomStock);
          }
          stockCountdown.dataset.initialized = "true";
        }
      });
  }

  changeLiveViewsNumber(liveViewElem, settings) {
    const numbElem = liveViewElem.querySelector(".live-view-numb");
    const { liveViewsDuration, liveViewsMax, liveViewsMin } = settings;
    const duration = Number(liveViewsDuration) || 5;
    const max = Number(liveViewsMax) || 30;
    const min = Number(liveViewsMin) || 20;

    if (numbElem) {
      setInterval(() => {
        const newViews = Math.floor(Math.random() * (max - min + 1)) + min;
        numbElem.textContent = newViews;
      }, duration * 1000);
    }
  }
}
customElements.define("m-visitiors-counter", MVisitorCounter);
